import { lazy } from "react";

const Admin = lazy(() => import("features/Admin/v2"));
const UserDetail = lazy(() => import("features/Admin/v2/Users/Detail"));
const OrderGroupDetail = lazy(() => import("features/Admin/v2/Orders/Detail"));
const StrategyDetail = lazy(() =>
  import("features/Admin/v2/Strategies/Detail")
);
const ConnectionDetail = lazy(() =>
  import("features/Admin/v2/Connections/Detail")
);

export const ADMIN_PATH = "/admin";
// The Tabs component reads `activeTab` from the query string.
export const ADMIN_USERS_PATH = `${ADMIN_PATH}?activeTab=users`;
export const ADMIN_USER_DETAIL_PATH = `${ADMIN_PATH}/users/:userId`;
export const ADMIN_STRATEGIES_PATH = `${ADMIN_PATH}?activeTab=strategies`;
export const ADMIN_STRATEGY_DETAIL_PATH = `${ADMIN_PATH}/strategies/:strategyId`;
export const ADMIN_ORDERS_PATH = `${ADMIN_PATH}?activeTab=orders`;
export const ADMIN_ORDER_DETAIL_PATH = `${ADMIN_PATH}/orders/:groupId`;
// Trading connections have no list tab of their own; the page is reached from
// the connections table of a user or a strategy.
export const ADMIN_CONNECTION_DETAIL_PATH = `${ADMIN_PATH}/connections/:tcId`;

export const adminUserDetailPath = (userId) => `${ADMIN_PATH}/users/${userId}`;

export const adminOrderDetailPath = (groupId) =>
  `${ADMIN_PATH}/orders/${groupId}`;

export const adminStrategyDetailPath = (strategyId) =>
  `${ADMIN_PATH}/strategies/${strategyId}`;

export const adminConnectionDetailPath = (tcId) =>
  `${ADMIN_PATH}/connections/${tcId}`;

export const adminRoutes = [
  {
    path: ADMIN_PATH,
    component: <Admin />,
  },
  {
    path: ADMIN_USER_DETAIL_PATH,
    component: <UserDetail />,
  },
  {
    path: ADMIN_ORDER_DETAIL_PATH,
    component: <OrderGroupDetail />,
  },
  {
    path: ADMIN_STRATEGY_DETAIL_PATH,
    component: <StrategyDetail />,
  },
  {
    path: ADMIN_CONNECTION_DETAIL_PATH,
    component: <ConnectionDetail />,
  },
];
